import React, { useState, useEffect } from 'react'
import { find, get, map, filter } from 'lodash'
import axios from 'axios'
import Select from 'react-select'

import FormError from './FormError'

export default ({data, clinic, callback}) => {
  console.log('clinic ', (clinic && clinic.name))

  const defaultFormValues = {
    fullName: '',
    email: '',
    clinic: '',
    directTo: '',
    message: ''
  }
  const [sending, setSending] = useState(false)
  const [formErrors, setFormErrors] = useState(defaultFormValues)
  const [formData, setFormData] = useState(defaultFormValues)

  const clinicOptions = map(data.clinics, (dc) => {
    return {
      label: dc.name,
      value: dc.name
    }
  })

  const departmentOptions = [
    {
      label: 'Doctors',
      value: 'Doctors'
    },
    {
      label: 'Front Desk',
      value: 'Front Desk'
    },
    { 
      label: 'Optical',
      value: 'Optical'
    },
    {
      label: 'Billing',
      value: 'Billing'
    },
  ]
  const directOptions = [...departmentOptions]



  useEffect(() => {
    if (clinic) {
      const _activeClinic =  find(data.clinics, (c) => {
        return c.name === clinic.name
      })
      if (_activeClinic) {
        setFormData({
          ...formData,
          clinic: _activeClinic ? { label: _activeClinic.name, value: _activeClinic.name } : ''
        })
      }
    }
  }, [clinic])

  const validField = (key) => {
    const value = formData[key]

    if (value === '') {
      setFormErrors({
        ...defaultFormValues,
        [key]: 'This is a required field'

      })
      return false
    }

    if (key === 'email') {
      let regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}')
      if (!regex.test(formData[key])) {
        setFormErrors({
          ...defaultFormValues,
          [key]: 'A valid email is required'
  
        })
        return false
      }
    }

    return true
  }

  const submitForm = (e) => {
    if (sending) return

    setSending(true)

    e.preventDefault()

    if (!validField('fullName')) return null

    if (!validField('email')) return null

    if (!validField('message')) return null

    console.log("can submit")
    const params = new URLSearchParams()
    params.append('full_name', formData.fullName)
    params.append('email', formData.email)
    params.append('message', formData.message)
    params.append('sent_at', new Date().toString())

    if (formData.clinic) params.append('clinic', get(formData, 'clinic.value'))
    if (formData.directTo) params.append('direct_to', get(formData, 'directTo.value'))

    let postURL = 'https://relay.zukko.com/scripts/contact.php'
    
    switch(get(formData, 'clinic.value')) {
      case 'queen anne':
        postURL = 'https://relay.zukko.com/scripts/contact_queenanne.php'
        break
      case 'ballard':
        postURL = 'https://relay.zukko.com/scripts/contact_ballard.php'
        break;
    }


    axios.post(postURL, params)
    .then(function (response) {
      if (get (response, 'data.status') === 'success') {
        callback(true)
      } else {
        // handle error
        console.log(get(response, 'data.errors'))
      }
    })
    .catch(function (response) {
      console.log('ERROR', get(response, 'data.errors'))
    })
  }


  const resetErrors = () => {
    setFormErrors(defaultFormValues)
  }

  return (
    <form className="ecs-form">
      <div className="mb-4 block">
        <div>
          <label className="required">
            Full Name
          </label>
          <input 
            type="text"
            name="fullName"
            value={formData.fullName} 
            className="text-sm md:text-normal"
            onChange={(e) => {
              resetErrors()
              setFormData({
                ...formData,
                fullName: e.currentTarget.value
              })
            }} 
          />
          <FormError message={formErrors.fullName} />

        </div>
      </div>
      <div className="mb-4 block">
        <div>
          <label className="required">
            E-Mail
          </label>
          <input 
            type="text"
            value={formData.email} 
            className="text-sm md:text-normal"
            name="e-mail"
            onChange={(e) => {
              resetErrors()
              setFormData({
                ...formData,
                email: e.currentTarget.value
              })
            }} 
          />
          <FormError message={formErrors.email} />
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        
        <div>
          <label>
            clinic
          </label>
          <Select 
            options={clinicOptions}
            value={formData.clinic}
            className="text-sm md:text-normal"
            onChange={(e) => {
              resetErrors()
              setFormData({
                ...formData,
                clinic: e
              })
            }}
          />
          <FormError message={formErrors.clinic} />
        </div>
        <div>
          <label>
            Direct to
          </label>
          <Select 
            options={directOptions}
            value={formData.directTo}
            className="text-sm md:text-normal"
            onChange={(e) => {
              resetErrors()
              setFormData({
                ...formData,
                directTo: e
              })
            }}
          />
          <FormError message={formErrors.directTo} />
        </div>
      </div>
      <div className="block mb-4">
        <label className="required">
          Message
        </label>
        <textarea
          value={formData.message}
          className="text-sm md:text-normal"
          onChange={
            (e) => {
              resetErrors()
              setFormData({
                ...formData,
                message: e.currentTarget.value
              })
            }
          } 
          rows={5}
        />
        <FormError message={formErrors.message} />
      </div>
      <div className="block mb-4">
        <button
          onClick={submitForm}
          className="block bg-white border-2 py-4 border-gray-200 uppercase text-sm tracking-[2px] font-semibold w-full hover:border-gray-700 hover:bg-gray-700 hover:text-white disabled:text-gray-400"
          disabled={sending}
        >
          { sending ? 'Sending Message' : 'Send Message' }
        </button>
      </div>
      <div className="text-sm py-4 italic">
        * required field
      </div>
    </form>
  )
}